import { JobPostIndexLayout } from "@/pages/_layouts/jobs/JobPostIndexLayout";
import { useLocation } from "react-router-dom";

export default function JobPostIndex() {
  const location = useLocation();
  const path = location.pathname.split("/jobs");
  const returnPath = path[0] + "/jobs";

  return <JobPostIndexLayout path={returnPath} title="Facility" />;
}
